<template lang="pug">
.question-list
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li.active
      span {{ $t('Safety Confirmation List') }}

  .row.margin-top(v-if="isSystemManagement")
    .col-sm-6
    .col-sm-6.text-right
      a.btn.btn-info(v-on:click="goSafetyConfirmationNew()")
          i.fa.fa-plus
          span {{ $t('New Registration') }}
  div
    div(v-if="searchEnd && safetyConfirmations.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-1 
                th.col-sm-3 タイトル
                th.col-sm-2.text-right 対象者人数
                th.col-sm-2.text-right 確認済人数
                th.col-sm-2 ステータス
                th.col-sm-2(v-if="isSystemManagement")
            tbody
              tr(v-for="(safetyConfirmation,index) in safetyConfirmations")
                td
                  span.badge(v-if="safetyConfirmation.attributes['is-training']", style="background-color: #0000cc") 訓練
                td 
                  a(v-on:click="goSafetyConfirmationAnswers(safetyConfirmation.id)") {{ safetyConfirmation.attributes.title }}
                td.text-right {{ safetyConfirmation.attributes['target-count'] }}
                td.text-right {{ safetyConfirmation.attributes['confirmed-count'] }}
                td {{ safetyConfirmation.attributes.status }}
                td(v-if="isSystemManagement" style="text-align: left;")
                  a(v-on:click="goSafetyConfirmationEdit(safetyConfirmation.id)").btn.btn-info.btn-sm.margin-right {{ $t('Edit') }}
                  a(v-if="!safetyConfirmation.attributes['is-closed']" v-on:click="safetyConfirmationClose(safetyConfirmation.id)").btn.btn-danger.btn-sm {{ $t('Close') }}

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && safetyConfirmations.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}

</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'service-question-list',
  created () {
    if (!this.isSystemManagement && !this.isShopMaster) {
      this.$router.push({ path: '/' })
    }
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      safetyConfirmations: [],
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return localStorage.is_shop_master === '1'
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (addSearch) {
      let data = {}
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }
      this.$store.dispatch('GET_SAFETY_CONFIRMATION_LIST', data)
      .then(res => {
        if (addSearch && res.confirmations) {
          this.safetyConfirmations = this.safetyConfirmations.concat(res.confirmations.data)
        } else {
          this.safetyConfirmations = res.confirmations ? res.confirmations.data : []
          this.searchEnd = true
        }
        this.nextExist = res.next_exist
      })
      .catch(err => console.log(err))
    },
    goSafetyConfirmationNew: function () {
      this.$router.push({ path: '/safety_confirmations/new' })
    },
    goSafetyConfirmationEdit: function (serviceConfirmationId) {
      this.$router.push({ path: '/safety_confirmations/' + serviceConfirmationId + '/edit' })
    },
    goSafetyConfirmationAnswers: function (serviceConfirmationId) {
      this.$router.push({ path: '/safety_confirmations/' + serviceConfirmationId + '/answers' })
    },
    safetyConfirmationClose: function (serviceConfirmationId) {
      if (window.confirm(this.$t('Confrim Closing Safety Confirmation'))) {
        this.$store.dispatch('CLOSE_SAFETY_CONFIRMATION', {
          id: serviceConfirmationId
        })
        .then(res => {
          this.search(false)
        })
        .catch(err => console.log(err))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SafetyConfirmationList.vue?5f0c1d98